export default __webpack_public_path__ + "static/media/8.38b6822b.jpg";